import script from "./SpeedAlertSubPreSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpeedAlertSubPreSetting.vue?vue&type=script&setup=true&lang=ts"

import "./SpeedAlertSubPreSetting.vue?vue&type=style&index=0&id=6609934e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6609934e"]])

export default __exports__